import { defaultLanguage } from 'constants/languages';
import trim from './trim';

type Hreflang = {
  rel: string;
  href: string;
  hreflang?: string;
};

enum relTypes {
  alternate = 'alternate',
  canonical = 'canonical',
  ogUrl = 'og:url',
}

const getHrefLangs = (
  languages: Record<string, unknown>,
  currentLanguage,
  pathName: string,
  isLocalized: boolean,
  canonicalUrl?: string,
): Hreflang[] => {
  const currentPageSlug = currentLanguage ? pathName.replace(`/${currentLanguage}`, '') : pathName;
  const canonicalLang = currentLanguage === defaultLanguage ? '' : `/${currentLanguage}`;

  const links = [];
  const path =
    currentPageSlug === '/' || currentPageSlug === '' ? '/' : `/${trim(currentPageSlug, '/')}/`;
  links.push({
    rel: relTypes.canonical,
    href: canonicalUrl || `${window.location.origin}${canonicalLang}${path}`,
  });

  if (isLocalized) {
    Object.keys(languages).forEach(lang => {
      const rel = relTypes.alternate;
      let href = `${window.location.origin}/${lang}${path}`;

      if (lang === defaultLanguage) {
        href = `${window.location.origin}${path}`;
        links.push({
          rel,
          href,
          hreflang: 'x-default',
        });
      }
      links.push({
        rel,
        href,
        hreflang: lang,
      });
    });
  }

  return links;
};

export default getHrefLangs;
